export default __webpack_public_path__ + "static/media/S_Sapo.e03d2d28.svg";